import { slideIn, slideOut, TranslatePipe } from '@myre/ui-primitive-core';

import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
} from '@angular/core';
import { type Observable } from 'rxjs';

import { fadeIn } from './helper';
import {
  NotificationService,
  type INotification,
  type NotificationStatus,
} from './notification.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [fadeIn, slideIn, slideOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslatePipe],
})
export class NotificationComponent {
  private _notificationService = inject(NotificationService);
  private _changeDetectorRef = inject(ChangeDetectorRef);

  @Input()
  public message: string;

  @Input()
  public status: NotificationStatus;

  @Input()
  public number: number;

  @Input()
  public hover: boolean = false;

  public notif$: Observable<INotification>;
  public fadein$: Observable<boolean>;
  public destroying: boolean = false;

  public onCloseNotificationClick(): void {
    this._notificationService.onClose(this.number);
  }

  public onMouseEnter(): void {
    this._notificationService.onMouseEnter(this.number);
  }

  public onMouseLeave(): void {
    this._notificationService.onMouseLeave(this.number);
  }

  public detectChanges(): void {
    this._changeDetectorRef.detectChanges();
  }
}
